import { useQuery } from '@tanstack/react-query';
import { claimsApi } from '../api/claims';

const POLL_INTERVAL_MS = 30_000;

export function useClaimsUnreadCount() {
  return useQuery({
    queryKey: ['claims', 'unread-count'],
    queryFn: () => claimsApi.unreadCount(),
    refetchInterval: POLL_INTERVAL_MS,
    refetchOnWindowFocus: true,
    staleTime: 5_000,
  });
}
